import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import WorkspaceItemInaccessibleGuard from 'auth/WorkspaceItemInaccessibleGuard';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {PMEIProcedureQuery} from 'procedures/worksheets/__generated/PMEIProcedureQuery';
import {navigateToStudyOverviewTab} from 'studies/FileUtils';
import Breadcrumbs, {CrumbLink} from 'ui-library/Breadcrumbs';
import * as Colors from 'ui-library/Colors';

type ProcedureRunNode = ExtractByTypename<
  PMEIProcedureQuery['procedureMethodExecutionInstance'],
  'ProcedureMethodExecutionInstanceNode'
>['procedureRun'];

interface WorksheetBreadcrumbsProps {
  procedureRun: ProcedureRunNode;
  worksheetName: string;
}

export default function WorksheetBreadcrumbs({
  procedureRun,
  worksheetName,
}: WorksheetBreadcrumbsProps): JSX.Element | null {
  const study = procedureRun.study;
  if (isInaccessible(study)) {
    return <WorkspaceItemInaccessibleGuard modelType={ModelTypeConstants.STUDY} inaccessibleInfo={study} />;
  } else {
    return (
      <div className={css(styles.worksheetBreadcrumbs)}>
        <Breadcrumbs keepCrumbsInline={true}>
          <CrumbLink
            onClick={() => {
              navigateToStudyOverviewTab(study.id);
            }}
            maxCrumbWidth={100}
          >
            {study.name}
          </CrumbLink>
          <CrumbLink
            onClick={() => {
              navigateToStudyOverviewTab(study.id, procedureRun.id);
            }}
            maxCrumbWidth={100}
          >
            {procedureRun.name}
          </CrumbLink>
        </Breadcrumbs>
        <div className={css(styles.worksheetName)}>{worksheetName}</div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  worksheetBreadcrumbs: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    whiteSpace: 'pre-wrap',
  },
  worksheetName: {
    maxWidth: '200px',
    fontSize: 13,
    color: Colors.GRAY_DARKER,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});
